import { lazy, Suspense } from 'react';
import { Header } from '@/components/Header';

// The widget pulls in the EVM/Solana/Tron wallet SDKs — several MB that the app shell
// does not need to become interactive. Loading it lazily keeps the entry chunk to the
// shell plus React.
const SwapWidget = lazy(() => import('./SwapWidget'));

/** Local skeleton: a Tailwind stand-in, so the fallback costs no extra bundle. */
function WidgetSkeleton() {
  return (
    <div
      className="animate-pulse rounded-3xl border border-white/10 bg-[hsl(222_47%_8%/0.8)] p-4"
      aria-label="Loading swap widget"
      role="status"
    >
      <div className="mb-4 ml-auto h-6 w-32 rounded-full bg-white/10" />
      <div className="mb-4 h-8 w-40 rounded-lg bg-white/10" />
      <div className="mb-3 grid grid-cols-2 gap-3">
        <div className="h-20 rounded-2xl bg-white/5" />
        <div className="h-20 rounded-2xl bg-white/5" />
      </div>
      <div className="mb-4 h-24 rounded-2xl bg-white/5" />
      <div className="h-12 rounded-full bg-white/10" />
    </div>
  );
}

function Home() {
  return (
    <main className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-4 py-10">
      <div className="w-full max-w-[460px]">
        <Suspense fallback={<WidgetSkeleton />}>
          <SwapWidget />
        </Suspense>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <div className="app-bg min-h-screen">
      <Header />
      <Home />
    </div>
  );
}
